export type RewardRarity = "common" | "rare" | "epic" | "legendary";
export type RewardType = "points" | "coupon";

export interface Reward {
  type: RewardType;
  value: number | string;
  rarity: RewardRarity;
  label: string;
  icon: string;
}

export type BoxVisualState =
  | "closed"
  | "hover"
  | "selected"
  | "opening"
  | "revealed"
  | "locked";

export interface MysteryBoxGameProps {
  className?: string;
  dailyAttemptsRemaining?: number;
  onRewardClaimed?: (reward: Reward) => void;
}

export interface MysteryBoxProps {
  id: number;
  state: BoxVisualState;
  isSelected: boolean;
  isCentered: boolean;
  reward?: Reward | null;
  disabled: boolean;
  onSelect: (id: number) => void;
  ariaLabel: string;
}

export interface RewardModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reward: Reward | null;
  onPlayAgain: () => void;
}

export type GamePhase = "idle" | "selected" | "opening" | "revealed" | "complete";

export const BOX_COUNT = 6;
